import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MsalService } from 'src/app/services/msal.service';

@Injectable()
export class RenewTokenInterceptor implements HttpInterceptor {

  constructor(private msalService: MsalService) { }

  goToNext(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request)
    .pipe(
        catchError((error: HttpErrorResponse) => {
          // console.log(error)
        if (error.status === 401) {
          this.msalService.logout();
        }
        return throwError(error);
      })
    );
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('./') || request.url.indexOf('/Get-GetSession') !== -1) {
      return this.goToNext(request, next);
    }

    if (localStorage.getItem('SessionID')) {
      request = request.clone({
        setHeaders: {
          SessionID: localStorage.getItem('SessionID')
        }
      });
      return this.goToNext(request, next);
    }
  }
}
